import { DataBean } from "../DataBean";

export class AppliedIncapacity extends DataBean {



    public async getMonthAppliedIncapacityCatalog(idIncapacity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getMonthAppliedIncapacityCatalog_Number", [idIncapacity]);
    }
}